export class ClickContext {
  private isDoubleClick = false;
  private call = 0;

  clickHandler(handler: ClickHandler): ClickHandler {
    return async (...args) => {
      // const call = this.call++;
      // console.log('[' + call + '] SIMPLE click ⬜️');
      await setTimeout(() => {
        if (!this.isDoubleClick) handler.apply(undefined, args);
        // this.isDoubleClick && console.log('[' + call + '] SIMPLE click 🟥')
        // !this.isDoubleClick && console.log('[' + call + '] SIMPLE click 🟩')
      }, 200);
    };
  }

  dblClickHandler(handler: ClickHandler): ClickHandler {
    this.isDoubleClick = true;
    return async (...args) => {
      // const call = this.call++;
      // console.log('[' + call + '] DOUBLE click ⬜️');
      handler.apply(undefined, args);
      // console.log('[' + call + '] DOUBLE click 🟩');
      await setTimeout(() => {
        this.isDoubleClick = false;
      }, 200);
    };
  }
}

type ClickHandler = (...args: unknown[]) => void;
